<div class="container" fxLayout="column">
  <mat-expansion-panel #mepFilter [(expanded)]="expandedFilterPanel">
    <mat-expansion-panel-header class="panel-container-header">
      <div [routerLink]="['/serviceRequest/details']">
        <h3 class="header__item">Nova Solicitação de Serviço</h3>
      </div>
      <div class="header__divider"></div>
      <div>
        <h3 class="header__item">Filtrar</h3>
      </div>
    </mat-expansion-panel-header>

    <mat-expansion-panel-body>
      <mat-divider></mat-divider>
      <form [formGroup]="filtersForm" #form="ngForm" novalidate>
        <div fxLayout="row" fxLayout.lt-md="column">
          <mat-form-field appearance="outline" fxFlex="20" fxFlex.lt-md="100">
            <mat-label>Número da Solicitação</mat-label>
            <input matInput formControlName="id" />
          </mat-form-field>

          <mat-form-field appearance="outline" fxFlex="50" fxFlex.lt-md="100">
            <mat-label>Status</mat-label>
            <mat-select
              id="status"
              name="status"
              formControlName="status"
              change
            >
              <mat-option value="">TODOS</mat-option>
              <mat-option value="30">Aguardando Envio</mat-option>
              <mat-option value="40">Em campo</mat-option>
              <mat-option value="50">Retornada de Campo</mat-option>
              <mat-option value="70">Cancelada</mat-option>
            </mat-select>
            <mat-hint
              *ngIf="
                !filtersForm.get('status').valid &&
                filtersForm.get('status').touched
              "
              class="error__input"
            >
              {{ filtersForm.get("status").errors | errorMessageFG }}
            </mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" fxFlex="30" fxFlex.lt-md="100">
            <mat-label>Técnico</mat-label>
            <mat-select id="agent" name="agent" formControlName="agent">
              <mat-option *ngFor="let agent of agents" [value]="agent.id">
                {{ agent.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" fxFlex="30" fxFlex.lt-md="100">
            <mat-label>Cliente</mat-label>
            <mat-select
              id="company"
              name="company"
              formControlName="company"
              change
            >
              <mat-option value="">TODAS</mat-option>
              <mat-option
                *ngFor="let company of companyOptions"
                [value]="company.alternativeIdentifier"
              >
                {{ company?.description }}
              </mat-option>
            </mat-select>
            <mat-hint
              *ngIf="
                !filtersForm.get('company').valid &&
                filtersForm.get('company').touched
              "
              class="error__input"
            >
              {{ filtersForm.get("company").errors | errorMessageFG }}
            </mat-hint>
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayout.lt-md="column">
          <mat-form-field appearance="outline" fxFlex="auto" fxFlex.lt-md="100">
            <mat-label>Regional</mat-label>
            <mat-select
              id="regional"
              name="regional"
              formControlName="regional"
            >
              <mat-option value="">TODAS</mat-option>
              <mat-option
                *ngFor="let regional of regionalOptions"
                [value]="regional.id"
              >
                {{ regional?.description }}
              </mat-option>
            </mat-select>
            <mat-hint
              *ngIf="
                !filtersForm.get('regional').valid &&
                filtersForm.get('regional').touched
              "
              class="error__input"
            >
              {{ filtersForm.get("regional").errors | errorMessageFG }}
            </mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" fxFlex="auto" fxFlex.lt-md="100">
            <mat-label>Localidade</mat-label>
            <mat-select
              id="serviceLocal"
              name="serviceLocal"
              formControlName="serviceLocal"
            >
              <mat-option value="">TODAS</mat-option>
              <mat-option
                *ngFor="let serviceLocal of serviceLocalOptions"
                [value]="serviceLocal.id"
              >
                {{ serviceLocal?.description }}
              </mat-option>
            </mat-select>
            <mat-hint
              *ngIf="
                !filtersForm.get('serviceLocal').valid &&
                filtersForm.get('serviceLocal').touched
              "
              class="error__input"
            >
              {{ filtersForm.get("serviceLocal").errors | errorMessageFG }}
            </mat-hint>
          </mat-form-field>
        </div>
      </form>

      <div
        class="container-buttom-search"
        fxLayoutAlign="space-between end"
        fxLayoutAlign.lt-md="center center"
        fxLayout="row"
        fxLayout.lt-md="column"
      >
        <button
          mat-raised-button
          color="primary"
          class="container-buttom-search__btn button-mobile"
          (click)="search()"
        >
          Procurar
        </button>
        <button
          mat-raised-button
          color="accent"
          class="container-buttom-search__btn margin-large-screen-right button-mobile"
          type="button"
          (click)="resetFilterForm()"
        >
          Limpar Filtro
        </button>
      </div>
    </mat-expansion-panel-body>
  </mat-expansion-panel>

  <app-pln-table
    [dataSource]="responseData"
    [displayedColumns]="displayedColumns"
    [tableActions]="tableActions"
    [currentPage]="tablePagination?.page || 1"
    (paginationEmitter)="handleFilter($event)"
    (actionEmitter)="handleAction($event)"
  ></app-pln-table>
</div>
